import { render, staticRenderFns } from "./DashboardSupplier.vue?vue&type=template&id=613fbd8b&scoped=true"
import script from "./DashboardSupplier.vue?vue&type=script&lang=js"
export * from "./DashboardSupplier.vue?vue&type=script&lang=js"
import style0 from "./DashboardSupplier.vue?vue&type=style&index=0&id=613fbd8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613fbd8b",
  null
  
)

export default component.exports